import axios from "axios";
import { authHeaderJson } from "../auth-header.service";


const createSectionPartyByBookId = (bookId, objSectionPartyList) => {
    return axios.put(`/api/sbBook/sectionparty/${bookId}/list`, objSectionPartyList, { headers: authHeaderJson() } );
};

const createAutomaticListSbSectionPartyMember = (bookId) => {
    //[##PATH ROUTE##]
    return axios.post(`/api/SbBook/sectionpartymember/${bookId}/automatic/list`, { headers: authHeaderJson() } )
};

const saveSectionPartyUsers = (bookId, sectionId, objSectionPartyUserList) => {
    return axios.put(`/api/SbBook/sectionpartymember/${bookId}/${sectionId}/list`, objSectionPartyUserList, { headers: authHeaderJson() });
};

const deleteSectionPartyById = (sectionPartyId) => {
    return axios.delete(`/api/SbBook/sectionparty/${sectionPartyId}`, { headers: authHeaderJson() });
};

const getSectionPartyUsersByPartyId = (partyId) => {
    return axios.get(`/api/sbBook/partymemberFP/${partyId}`, { headers: authHeaderJson() } );
};

const getSectionPartyUsersBySectionId = (sectionId, partyId) => {
    return axios.get(`/api/sbBook/sectionpartymemberFS/${sectionId}/${partyId}/list`, { headers: authHeaderJson() } );
};

const deleteSectionPartyUserById = (sectionPartyUserId) => {
    return axios.delete(`/api/SbBook/sectionpartymember/${sectionPartyUserId}`, { headers: authHeaderJson() });
};

const disableSectionPartyUserById = (sectionPartyUserId) => {
    return axios.post(`/api/SbBook/partymemberdisable/${sectionPartyUserId}`, { headers: authHeaderJson() } )
};

const getSectionPartysByBookId = (bookId) => {
    return axios.get(`/api/sbBook/sectionpartyfull/${bookId}/0/list`, { headers: authHeaderJson() } );
};


export {
    createSectionPartyByBookId,
    deleteSectionPartyById,
    getSectionPartyUsersByPartyId,
    getSectionPartyUsersBySectionId,
    getSectionPartysByBookId,
    saveSectionPartyUsers,
    deleteSectionPartyUserById,
    disableSectionPartyUserById,
    createAutomaticListSbSectionPartyMember
}